import styled from 'styled-components';
import { css } from '@emotion/css';
import Color from 'styles/colors';

export const scrollableItemView = (paddingLeft: string = '0px') => css`
  display: flex;
  flex: 1;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  background-color: white;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  padding-left: ${paddingLeft};
`;

export const titledScrollableItemView = css`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Color.Gray['30']};
`;

export const scrollableItemTitle = css`
  width: 90px;
  min-width: 70px;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: 1.25rem;
  height: 39px;
  line-height: 39px;
`;

export const filterResetButton = css`
  cursor: pointer;
  display: flex;
  color: ${Color.Gray['60']};
  font-weight: normal;
  gap: 4px;
`;

export const tag = css`
  display: flex;
  color: white;
  padding: 4px 6px;
  color: ${Color.White};
  background-color: ${Color.Primary};
  font-size: 12px;
  border-radius: 6px;
  margin: 0px 8px;
  cursor: pointer;
`;

export const moreFilterRow = css`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Color.Primary};
  font-size: 12px;
  font-weight: bold;
  height: 39px;
`;

export const horizonDivider = css`
  height: 8px;
  background: ${Color.Gray['20']};
`;

export const filterItem = (selected: boolean) => css`
  font-size: 0.75rem;
  padding: 0.5rem 0.75rem;
  color: ${selected ? Color.Primary : Color.Gray['70']};
  font-weight: ${selected ? '700' : '400'};
  cursor: pointer;
`;

export const filterDeleteButton = css`
  width: 14px;
  display: flex;
  align-items: center;
  justify-content: right;
`;
